export default __webpack_public_path__ + "static/media/security-manager-lower-right.83cf15eb.png";